import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import "./Utility.css";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";

export const Utility = () => {
  useEffect(() => {
    gsap.registerPlugin(ScrollTrigger);
    if (window.screen.width > 1199) {
      gsap.from(".single__benefit", {
        x: "-200px",
        // filter: "blur(5px)",
        stagger: 0.5,
        opacity: "0",
        duration: 0.5,
        scrollTrigger: {
          trigger: ".single__benefit",
          // scrub:"0.25",
          // end:"+=600px"
          // start:"top"
        },
      });

      // gsap.from(".single__benefit p",{
      //   x:"-200px",
      //   // filter: "blur(5px)",
      //   stagger:0.5,
      //   opacity:"0",
      //   duration:0.5,
      //   scrollTrigger:{
      //     trigger:".single__benefit p",
      //     // scrub:"0.25",
      //     // end:"+=600px"
      //     // start:"top"
      //   },
      // })
    }

    if (window.screen.width < 992) {
      gsap.from(".single__benefit", {
        x: "-200px",
        // filter: "blur(5px)",
        stagger: 0.5,
        opacity: "0",
        duration: 0.5,
        scrollTrigger: {
          trigger: ".single__benefit",
          // scrub:"0.25",
          // end:"+=600px"
          // start:"top"
        },
      });
    }
  }, []);

  return (
    <div className="utility pd-b-100 pd-t-80" id="utility">
      <Container>
        <Row>
          <Col md={12}>
            <h2>Benefits and Utilities</h2>
            {/* <h3>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam non
              mi lacinia, mollis mauris sed, finibus lectus. Cras sit amet
              condimentum neque. Sed varius urna ante, eget euismod risus
              tristique eget. Maecenas vehicula massa sit amet tristique
              pellentesque.
            </h3> */}
          </Col>
          <Col md={4}>
            <div className="single__benefit">
              <h3>HOLDERS REWARDING</h3>
              <p>
                Users can participate in sports and earn profits by holding
                NFTs. Of course, before our running application is launched ,
                users can stake their NFTs on the official website to obtain
                similar benefits. Get $RMC tokens by staking NFT, holding $RMC
                token to earn $GMT dividends which is triple profit.
              </p>
            </div>
          </Col>
          <Col md={4}>
            <div className="single__benefit">
              <h3>Grade income distribution</h3>
              <p>
                A total of 1000 pairs of running shoes, 15 top ranking with
                wings and a shimmering colour, 39 with diamond 67 with golden
                sole , 150 with silver lace or dragon pattern , others are basic
                shoes. The income is arranged from high to low, users can
                upgrade by purchasing corresponding equipment Running shoes get
                higher returns.
              </p>
            </div>
          </Col>
          <Col md={4}>
            <div className="single__benefit">
              <h3>COMMUNITY NFT</h3>
              <p>
                1000 pairs of running shoes NFT is the privileged NFT of the RMC
                community. Users enjoy all the benefits of the community,
                including the opportunity to experience all products in advance,
                as well as airdrops from other cooperative communities.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};
